export const HIGHWAYS_BASE_PATH = `/highways`;
export const RoutesList = {
  HIGHWAYS_HOME: HIGHWAYS_BASE_PATH,
  TEST_LANDING_PAGE: '/',
  UPLOAD_PHOTO: HIGHWAYS_BASE_PATH + '/upload-photo',
  HIGHWAYS_DAMAGE: HIGHWAYS_BASE_PATH + '/highways-damage',
  HIGHWAYS_DAMAGE_TYPE: HIGHWAYS_BASE_PATH + '/highways-damage-type',
  ANYTHING_ELSE: HIGHWAYS_BASE_PATH + '/anything-else',
  YOUR_DETAILS: HIGHWAYS_BASE_PATH + '/your-details',
  CONFIRMATION: HIGHWAYS_BASE_PATH + '/confirmation',
  ISSUE_LOCATION: HIGHWAYS_BASE_PATH + '/issue-location',
  EMAIL_CONFIRMATION_REPORT: HIGHWAYS_BASE_PATH + '/email-confirmation-report',
  TFL_REPORT: HIGHWAYS_BASE_PATH + '/report-to-tfl',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
  CALL_US: HIGHWAYS_BASE_PATH + '/call-us',
  CALLBACKS: '/callbacks/*',
};

export const steps = [
  {
    label: 'Damage details',
    urlPaths: [
      RoutesList.UPLOAD_PHOTO,
      RoutesList.HIGHWAYS_DAMAGE,
      RoutesList.HIGHWAYS_DAMAGE_TYPE,
    ],
  },
  {
    label: 'Location',
    urlPaths: [
      RoutesList.ISSUE_LOCATION,
      RoutesList.ANYTHING_ELSE,
      RoutesList.TFL_REPORT,
    ],
  },
  {
    label: 'Your details',
    urlPaths: [RoutesList.YOUR_DETAILS, RoutesList.EMAIL_CONFIRMATION_REPORT],
  },
];
